import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Container, CircularProgress } from '@mui/material';
import { Header } from '../components/Header';
import { useTranslation } from 'react-i18next';

export function Noticias({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null); // Create a ref to access the iframe element

  useEffect(() => {
    const iframe = iframeRef.current;
    
    if (!iframe) return; // Exit if iframe is not available

    const handleIframeLoad = () => {
      setLoading(false); // Set loading to false once the iframe is fully loaded
    };

    // Attach the event listener to the iframe's load event
    iframe.addEventListener('load', handleIframeLoad);

    // Clean up the event listener when the component unmounts
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad);
      }
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Header setIsAuthenticated={setIsAuthenticated} />

      <Container
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
        }}
      >
        <Box sx={{ my: 4, width: '100%' }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#50A579',
              fontWeight: 'bold',
            }}
          >
            {t('news.title')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 4,
            }}
          >
            {loading && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '60vh',
                }}
              >
                <CircularProgress
                  sx={{
                    color: 'rgba(80, 165, 121, 0.7)',
                  }}
                />
              </Box>
            )}
            <iframe
              ref={iframeRef}
              src="https://instagram.com/vila_training/embed"
              width="100%"
              height="420"
              frameBorder="0"
              scrolling="no"
              style={{
                border: 'none',
                overflow: 'hidden',
                display: loading ? 'none' : 'block',
              }}
            ></iframe>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
